import React from "react";
import { Avatar, Button, Input, Segmented, Typography } from "antd";
import {
  MenuOutlined,
  MoonOutlined,
  SearchOutlined,
  SunOutlined,
} from "@ant-design/icons";
import { useThemeMode } from "../../context/ThemeContext";
import { UserIcon } from "../../icons";

const { Text } = Typography;

export function Topbar({
  currentUser,
  onToggleSidebar,
  showSidebarToggle = false,
}) {
  const { mode, setMode } = useThemeMode();

  return (
    <div className="topbar-inner">
      <div className="topbar-left">
        {showSidebarToggle ? (
          <Button
            type="text"
            className="icon-button sidebar-toggle-button"
            icon={<MenuOutlined />}
            aria-label="Toggle sidebar"
            onClick={onToggleSidebar}
          />
        ) : null}
        <Input
          className="topbar-search"
          placeholder="Search agents, intents, or knowledge..."
          prefix={<SearchOutlined />}
          allowClear
        />
      </div>

      <div className="topbar-actions">
        <Segmented
          size="middle"
          value={mode}
          onChange={setMode}
          className="topbar-segmented"
          options={[
            { label: <SunOutlined />, value: "light" },
            { label: <MoonOutlined />, value: "black" },
          ]}
        />

        <div className="topbar-user">
          <div className="topbar-user-meta">
            <div className="topbar-user-name">{currentUser?.name}</div>
            <Text className="topbar-user-role">{currentUser?.role}</Text>
          </div>
          <Avatar className="avatar">
            <UserIcon style={{ width: 16, height: 16 }} />
          </Avatar>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
